import axios, { AxiosError } from 'axios';

import { studentGateway } from '../student-gateway';

export const currentSession = async (): Promise<any | Error> => {
    try {
        const session = await studentGateway.get(
            '/programmes/current/sessions/current',
            {
                withCredentials: true,
            },
        );
        return session.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const err = error as AxiosError;
            if (err.response && err.response.status === 404) {
                return null;
            } else {
                throw error;
            }
        }
    }
};

export const lastUncompletedSession = async (): Promise<any | Error> => {
    try {
        const session = await studentGateway.get(
            '/programmes/current/sessions/last_uncompleted',
            {
                withCredentials: true,
            },
        );
        return session.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const err = error as AxiosError;
            if (err.response && err.response.status === 404) {
                return null;
            } else {
                throw error;
            }
        }
    }
};

export const currentClassroom = async (): Promise<any | Error> => {
    const classroom = await studentGateway.get(
        '/programmes/current/sessions/current/classroom',
        {
            withCredentials: true,
        },
    );
    return classroom.data;
};

export const initiateSelfLaunchedSession = async (
    subjectId?: number,
    resume?: boolean,
): Promise<{ id: number } | Error> => {
    try {
        const response = await studentGateway.post(
            '/sessions',
            {
                subject_id: subjectId,
                ...(resume && { resume }),
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response.data;
    } catch (error) {
        throw new Error('Oh Uh, we cannot initiate a session right now!');
    }
};

export const submitPostSessionFeedback = async (
    response: string,
    score: number,
    sessionId?: number,
): Promise<any> => {
    try {
        const apiResponse = await studentGateway.post(
            `/sessions/${sessionId}/survey`,
            {
                response,
                score,
            },
        );
        return apiResponse.data;
    } catch (error) {
        throw new Error('Something went wrong saving your feedback.');
    }
};
